module.exports = __webpack_public_path__ + "media/damages/miejsce-uszkodzenia@2x-30b1a3f5.png";